import React from 'react';
import { useAtomValue } from 'jotai';
import {
  isExpiredAtom,
  subjectSubscriptionAtom,
} from '@components/subscription/store/SubscriptionAtoms';
import MiniOverview from '@components/subscription/overview/micro/MiniOverview';
import { IPlanOverviewDetail } from '@models/interfaces/user.interface';
import { getPlanContent } from '@components/subscription/overview/detail/PlanContent';

export interface ActivePlanDetailProps {
  planDetail: IPlanOverviewDetail;
}

const ActivePlanDetail = ({ planDetail }: ActivePlanDetailProps) => {
  const isExpired = useAtomValue(isExpiredAtom);
  const subscription = useAtomValue(subjectSubscriptionAtom);
  const items = getPlanContent(planDetail);

  if (!subscription) {
    return null;
  }

  return (
    <div>
      <div
        className={
          'p-4 rounded-t-2xl ' +
          (isExpired ? 'bg-neutral-graphite' : 'bg-primary-navyblue-shade')
        }
        data-testid={'top-overview'}
      >
        <MiniOverview
          subscription={subscription}
          planDetail={planDetail}
          isExpired={isExpired}
        />
      </div>
      <div className={'px-4 py-2 bg-neutral-chalk rounded-b-2xl'}>
        {items.map((item, index) => (
          <div key={index} className={'flex py-2 text-neutral-marker'}>
            <div className={'relative w-1 mr-2'}>
              <div
                className={
                  'w-1 h-1 rounded-full absolute left-0 top-[8px] bg-neutral-marker'
                }
              />
            </div>
            <div>
              <div
                className={
                  'lg:text-md lg:leading-[22px] max-lg:text-sm max-lg:leading[19px]'
                }
              >
                {item.main}
              </div>
              <div
                className={
                  'lg:text-sm lg:leading-[19px] lg:font-bold max-lg:text-xs max-lg:leading[16px] max-lg:font-semibold text-neutral-graphite'
                }
              >
                {item.secondary}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivePlanDetail;
